import { CHATBOX, setCHATBOX } from "../client";
import chatbox_arr from "../styles/chatbox/chatboxes.js";

/**
 * Aliases for character `chat=` values that should reuse an existing chatbox
 * theme under a different name. e.g. a character with `chat=soj` gets the same
 * box as `chat=dd`, and `chat=dgsenglish` gets the same box as `chat=dgs`.
 */
const CHATBOX_ALIASES: Record<string, string> = {
  soj: "dd",
  dgsenglish: "dgs",
};

/**
 * Set the style of the chatbox
 */
export function setChatbox(setstyle: string) {
  const chatbox_theme = <HTMLAnchorElement>(
    document.getElementById("chatbox_theme")
  );
  const themeselect = <HTMLSelectElement>(
    document.getElementById("client_chatboxselect")
  );
  setCHATBOX(themeselect.value);

  localStorage.setItem("chatbox", CHATBOX);
  if (CHATBOX === "dynamic") {
    let style = setstyle.replace("chat", "");
    style = CHATBOX_ALIASES[style.toLowerCase()] ?? style;
    if (chatbox_arr.includes(style)) {
      chatbox_theme.href = `styles/chatbox/${style}.css`;
    } else {
      chatbox_theme.href = "styles/chatbox/aa.css";
    }
  } else {
    chatbox_theme.href = `styles/chatbox/${CHATBOX}.css`;
  }
}
window.setChatbox = setChatbox;
